<mat-sidenav-container>
  <mat-sidenav
    class="admin-main-sidenav fixed-sidenav clear-sidenav-background"
    #mainSidenav
    [mode]="'side'"
    [opened]="true"
    [disableClose]="true"
    position="start"
    (openedStart)="openedStart()"
    (openedChange)="mainSidenavToggled($event)">
    <app-beta-menu></app-beta-menu>
  </mat-sidenav>
  <mat-sidenav-content class="admin-main-content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
  <mat-sidenav class="admin-alt-sidenav fixed-sidenav" #altSidenav mode="over" opened="false" position="end" (openedChange)="altSidenavToggled($event)">
    <app-dynamic-menu></app-dynamic-menu>
  </mat-sidenav>
  <app-business-menu *ngIf="showBusinessMenu"></app-business-menu>
</mat-sidenav-container>
